import { createBrowserHistory } from "history";

let history = createBrowserHistory();

export default history;
